import { connect } from 'react-redux'
import ViewRole from 'modules/ViewRole/index'
import selector from 'modules/Applied_Roles/selectors'
import selector1 from 'modules/ViewRole/selectors'
import {getSingleRoleDetails, SaveRole, ApplyRole, jobSharingEmail} from 'modules/ViewRole/actions'
import selector2 from 'modules/Onboarding/selectors'

const mapStateToProps = state => ({
    viewRoleData: selector.getViewRoleData(state),
     viewRoleDetails: selector1.getSingleRoleDetail(state),
     collegeData: selector2.getCampuDetails(state),
})

const mapDispatchToProps = {
     getSingleRoleDetails,
    SaveRole,
    ApplyRole,
    jobSharingEmail
    
    

}

export default connect(mapStateToProps, mapDispatchToProps)(ViewRole)
